import { IconArrowDown16, IconArrowUp16, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IShowMoreLinkProps {
  isExpanded: boolean;
  onClick: () => void;
}

export const ReadMore: React.FunctionComponent<IShowMoreLinkProps> = ({ isExpanded, onClick }) => {
  return (
    <div className={styles['read_more']} onClick={onClick} data-testid="read_more">
      <UIText2 color="primary_100">{isExpanded ? 'Свернуть' : 'Читать дальше'}</UIText2>
      <span className={styles['icon']}>
        {isExpanded ? <IconArrowUp16 color="primary_100" /> : <IconArrowDown16 color="primary_100" />}
      </span>
    </div>
  );
};
